import React from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect, Link } from 'react-router-dom';
import LevelList from './LevelList';

function Levels(props) {
  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const renderLevels = () => {
    const { levels } = props;
    if (levels) {
      return (
        <div className="row">
          <LevelList levels={levels} />
        </div>
      );
    }
  };

  return (
    <div className="dashboard container">
      {renderLevels()}
      <Link className="btn-floating btn-large fixed-action-btn green right" to="level">
        <i className="material-icons">add</i>
      </Link>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    levels: state.firestore.ordered.levels,
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps), firestoreConnect([{ collection: 'levels', orderBy: ['levelName', 'asc'] }]))(Levels);
